import { useEffect } from "react"
import { closeSnackbar, enqueueSnackbar } from "notistack"
import { GlobalMachineContext } from "../../../study-plans/pages/StudyPlansInit/StudyPlansInit"

export const useMachineSnackbar = () => {
  const actorRef = GlobalMachineContext.useActorRef()
  const { send } = actorRef
  const { snackbar } = GlobalMachineContext.useSelector(state => ({
    snackbar: state.context.snackbar
  }))

  useEffect(() => {
    if (!snackbar?.message) return

    enqueueSnackbar(snackbar.message, {
      variant: snackbar?.variant,
      ...(snackbar?.withUndo && {
        action: {
          UNDO: () => {
            send(snackbar.undoEvent ?? { type: "UNDO" })
            closeSnackbar()
          }
        }
      }),
      ...(snackbar.error && {
        autoHideDuration: 10000,
        variant: "error"
      })
    })
  }, [snackbar])
}
